import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dashboard-emp',
  templateUrl: './dashboard-emp.component.html',
  styleUrls: ['./dashboard-emp.component.css']
})
export class DashboardEmpComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
